import { ReactNode, useCallback, useContext, useEffect, useRef, useState } from 'react';

import styles from '@components/HoverText.module.css';
import { popoverContext } from '@context/PopoverStore';

type Props = {
  children: ReactNode;
  content: ReactNode;
};

const HoverText = ({ children, content }: Props) => {
  const showingPopover = useRef<boolean>(false);
  const [displayTimeout, setDisplayTimeout] = useState<NodeJS.Timeout>();
  const { hidePopover, showPopover } = useContext(popoverContext);

  const showHoverText = useCallback(
    (event: React.MouseEvent) => {
      if (!showingPopover.current) {
        showingPopover.current = true;
        setDisplayTimeout(
          setTimeout(() => {
            showPopover(content, event);
          }, 100)
        );
      }
    },
    [content, showPopover]
  );

  const hideHoverText = useCallback(
    (event: React.MouseEvent) => {
      showingPopover.current = false;
      if (displayTimeout) {
        clearInterval(displayTimeout);
      }
      hidePopover(content, event);
    },
    [content, displayTimeout, hidePopover]
  );

  useEffect(() => {
    if (displayTimeout) {
      clearInterval(displayTimeout);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (content === undefined) {
    return <>{children}</>;
  }

  return (
    <div
      className={styles.eventCatcher}
      onClick={event => hideHoverText(event)}
      onMouseEnter={event => showHoverText(event)}
      onMouseLeave={event => hideHoverText(event)}
      onMouseMove={event => showHoverText(event)}
    >
      {children}
    </div>
  );
};

export default HoverText;
